// Timezone utilities for EMS
// Provides consistent timezone handling across the application

// Common timezones for exercise management
export const TIMEZONES = [
  { value: 'UTC', label: 'UTC (Coordinated Universal Time)', offset: 0 },
  // Americas
  { value: 'America/New_York', label: 'US Eastern (New York)', offset: -5 },
  { value: 'America/Chicago', label: 'US Central (Chicago)', offset: -6 },
  { value: 'America/Denver', label: 'US Mountain (Denver)', offset: -7 },
  { value: 'America/Los_Angeles', label: 'US Pacific (Los Angeles)', offset: -8 },
  { value: 'America/Anchorage', label: 'US Alaska (Anchorage)', offset: -9 },
  { value: 'America/Honolulu', label: 'US Hawaii (Honolulu)', offset: -10 },
  { value: 'America/Phoenix', label: 'US Arizona (Phoenix)', offset: -7 },
  { value: 'America/Toronto', label: 'Canada Eastern (Toronto)', offset: -5 },
  { value: 'America/Vancouver', label: 'Canada Pacific (Vancouver)', offset: -8 },
  { value: 'America/Halifax', label: 'Canada Atlantic (Halifax)', offset: -4 },
  { value: 'America/St_Johns', label: 'Canada Newfoundland', offset: -3.5 },
  { value: 'America/Mexico_City', label: 'Mexico (Mexico City)', offset: -6 },
  { value: 'America/Bogota', label: 'Colombia (Bogota)', offset: -5 },
  { value: 'America/Lima', label: 'Peru (Lima)', offset: -5 },
  { value: 'America/Santiago', label: 'Chile (Santiago)', offset: -4 },
  { value: 'America/Buenos_Aires', label: 'Argentina (Buenos Aires)', offset: -3 },
  { value: 'America/Sao_Paulo', label: 'Brazil (Sao Paulo)', offset: -3 },
  { value: 'America/Caracas', label: 'Venezuela (Caracas)', offset: -4 },
  // Europe
  { value: 'Europe/London', label: 'UK (London)', offset: 0 },
  { value: 'Europe/Dublin', label: 'Ireland (Dublin)', offset: 0 },
  { value: 'Europe/Lisbon', label: 'Portugal (Lisbon)', offset: 0 },
  { value: 'Europe/Paris', label: 'France (Paris)', offset: 1 },
  { value: 'Europe/Berlin', label: 'Germany (Berlin)', offset: 1 },
  { value: 'Europe/Amsterdam', label: 'Netherlands (Amsterdam)', offset: 1 },
  { value: 'Europe/Brussels', label: 'Belgium (Brussels)', offset: 1 },
  { value: 'Europe/Madrid', label: 'Spain (Madrid)', offset: 1 },
  { value: 'Europe/Rome', label: 'Italy (Rome)', offset: 1 },
  { value: 'Europe/Zurich', label: 'Switzerland (Zurich)', offset: 1 },
  { value: 'Europe/Vienna', label: 'Austria (Vienna)', offset: 1 },
  { value: 'Europe/Warsaw', label: 'Poland (Warsaw)', offset: 1 },
  { value: 'Europe/Prague', label: 'Czech Republic (Prague)', offset: 1 },
  { value: 'Europe/Budapest', label: 'Hungary (Budapest)', offset: 1 },
  { value: 'Europe/Bucharest', label: 'Romania (Bucharest)', offset: 2 },
  { value: 'Europe/Athens', label: 'Greece (Athens)', offset: 2 },
  { value: 'Europe/Helsinki', label: 'Finland (Helsinki)', offset: 2 },
  { value: 'Europe/Stockholm', label: 'Sweden (Stockholm)', offset: 1 },
  { value: 'Europe/Oslo', label: 'Norway (Oslo)', offset: 1 },
  { value: 'Europe/Copenhagen', label: 'Denmark (Copenhagen)', offset: 1 },
  { value: 'Europe/Moscow', label: 'Russia (Moscow)', offset: 3 },
  { value: 'Europe/Istanbul', label: 'Turkey (Istanbul)', offset: 3 },
  // Africa
  { value: 'Africa/Cairo', label: 'Egypt (Cairo)', offset: 2 },
  { value: 'Africa/Lagos', label: 'Nigeria (Lagos)', offset: 1 },
  { value: 'Africa/Nairobi', label: 'Kenya (Nairobi)', offset: 3 },
  { value: 'Africa/Johannesburg', label: 'South Africa (Johannesburg)', offset: 2 },
  { value: 'Africa/Casablanca', label: 'Morocco (Casablanca)', offset: 1 },
  { value: 'Africa/Addis_Ababa', label: 'Ethiopia (Addis Ababa)', offset: 3 },
  { value: 'Africa/Accra', label: 'Ghana (Accra)', offset: 0 },
  { value: 'Africa/Tunis', label: 'Tunisia (Tunis)', offset: 1 },
  { value: 'Africa/Algiers', label: 'Algeria (Algiers)', offset: 1 },
  { value: 'Africa/Tripoli', label: 'Libya (Tripoli)', offset: 2 },
  { value: 'Africa/Khartoum', label: 'Sudan (Khartoum)', offset: 2 },
  // Middle East
  { value: 'Asia/Dubai', label: 'UAE (Dubai)', offset: 4 },
  { value: 'Asia/Riyadh', label: 'Saudi Arabia (Riyadh)', offset: 3 },
  { value: 'Asia/Tehran', label: 'Iran (Tehran)', offset: 3.5 },
  { value: 'Asia/Baghdad', label: 'Iraq (Baghdad)', offset: 3 },
  { value: 'Asia/Jerusalem', label: 'Israel (Jerusalem)', offset: 2 },
  { value: 'Asia/Kuwait', label: 'Kuwait (Kuwait City)', offset: 3 },
  { value: 'Asia/Muscat', label: 'Oman (Muscat)', offset: 4 },
  { value: 'Asia/Qatar', label: 'Qatar (Doha)', offset: 3 },
  { value: 'Asia/Bahrain', label: 'Bahrain (Manama)', offset: 3 },
  { value: 'Asia/Aden', label: 'Yemen (Aden)', offset: 3 },
  { value: 'Asia/Amman', label: 'Jordan (Amman)', offset: 3 },
  { value: 'Asia/Beirut', label: 'Lebanon (Beirut)', offset: 2 },
  { value: 'Asia/Damascus', label: 'Syria (Damascus)', offset: 3 },
  { value: 'Asia/Gaza', label: 'Palestine (Gaza)', offset: 2 },
  { value: 'Asia/Nicosia', label: 'Cyprus (Nicosia)', offset: 2 },
  { value: 'Asia/Baku', label: 'Azerbaijan (Baku)', offset: 4 },
  { value: 'Asia/Tbilisi', label: 'Georgia (Tbilisi)', offset: 4 },
  { value: 'Asia/Yerevan', label: 'Armenia (Yerevan)', offset: 4 },
  // South Asia
  { value: 'Asia/Kolkata', label: 'India (Mumbai/Delhi)', offset: 5.5 },
  { value: 'Asia/Colombo', label: 'Sri Lanka (Colombo)', offset: 5.5 },
  { value: 'Asia/Dhaka', label: 'Bangladesh (Dhaka)', offset: 6 },
  { value: 'Asia/Karachi', label: 'Pakistan (Karachi)', offset: 5 },
  { value: 'Asia/Kathmandu', label: 'Nepal (Kathmandu)', offset: 5.75 },
  // Southeast Asia
  { value: 'Asia/Bangkok', label: 'Thailand (Bangkok)', offset: 7 },
  { value: 'Asia/Singapore', label: 'Singapore', offset: 8 },
  { value: 'Asia/Kuala_Lumpur', label: 'Malaysia (Kuala Lumpur)', offset: 8 },
  { value: 'Asia/Jakarta', label: 'Indonesia (Jakarta)', offset: 7 },
  { value: 'Asia/Ho_Chi_Minh', label: 'Vietnam (Ho Chi Minh)', offset: 7 },
  { value: 'Asia/Manila', label: 'Philippines (Manila)', offset: 8 },
  // East Asia
  { value: 'Asia/Shanghai', label: 'China (Shanghai)', offset: 8 },
  { value: 'Asia/Hong_Kong', label: 'Hong Kong', offset: 8 },
  { value: 'Asia/Taipei', label: 'Taiwan (Taipei)', offset: 8 },
  { value: 'Asia/Tokyo', label: 'Japan (Tokyo)', offset: 9 },
  { value: 'Asia/Seoul', label: 'South Korea (Seoul)', offset: 9 },
  // Oceania
  { value: 'Australia/Sydney', label: 'Australia Eastern (Sydney)', offset: 10 },
  { value: 'Australia/Melbourne', label: 'Australia (Melbourne)', offset: 10 },
  { value: 'Australia/Brisbane', label: 'Australia (Brisbane)', offset: 10 },
  { value: 'Australia/Perth', label: 'Australia Western (Perth)', offset: 8 },
  { value: 'Australia/Adelaide', label: 'Australia Central (Adelaide)', offset: 9.5 },
  { value: 'Australia/Darwin', label: 'Australia (Darwin)', offset: 9.5 },
  { value: 'Pacific/Auckland', label: 'New Zealand (Auckland)', offset: 12 },
  { value: 'Pacific/Fiji', label: 'Fiji', offset: 12 },
  { value: 'Pacific/Guam', label: 'Guam', offset: 10 },
  { value: 'Pacific/Tongatapu', label: 'Tonga (Tongatapu)', offset: 13 },
  // Central Asia
  { value: 'Asia/Almaty', label: 'Kazakhstan (Almaty)', offset: 6 },
  { value: 'Asia/Tashkent', label: 'Uzbekistan (Tashkent)', offset: 5 },
  { value: 'Asia/Vladivostok', label: 'Russia (Vladivostok)', offset: 10 },
  { value: 'Asia/Yangon', label: 'Myanmar (Yangon)', offset: 6.5 },
];

// Get timezone offset in hours from UTC
export const getTimezoneOffset = (timezone) => {
  try {
    const now = new Date();
    const utcDate = new Date(now.toLocaleString('en-US', { timeZone: 'UTC' }));
    const tzDate = new Date(now.toLocaleString('en-US', { timeZone: timezone }));
    return (tzDate - utcDate) / (1000 * 60 * 60);
  } catch (e) {
    return 0;
  }
};

// Get user's local timezone
export const getUserTimezone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

// Get user's local timezone offset
export const getUserOffset = () => {
  return -new Date().getTimezoneOffset() / 60;
};

// Format timezone offset as string like "+5:30" or "-8:00"
export const formatOffset = (offset) => {
  const sign = offset >= 0 ? '+' : '-';
  const absOffset = Math.abs(offset);
  const hours = Math.floor(absOffset);
  const minutes = Math.round((absOffset - hours) * 60);
  return `${sign}${hours}:${minutes.toString().padStart(2, '0')}`;
};

// Get relative offset between exercise timezone and user's local time
export const getRelativeOffset = (exerciseTimezone) => {
  const exerciseOffset = getTimezoneOffset(exerciseTimezone);
  const userOffset = getUserOffset();
  const diff = exerciseOffset - userOffset;
  
  if (diff === 0) {
    return 'Same as your local time';
  } else if (diff > 0) {
    return `${Math.abs(diff)} hour${Math.abs(diff) !== 1 ? 's' : ''} ahead of your time`;
  } else {
    return `${Math.abs(diff)} hour${Math.abs(diff) !== 1 ? 's' : ''} behind your time`;
  }
};

// Format a date/time in exercise timezone
export const formatInTimezone = (dateString, timezone, options = {}) => {
  if (!dateString) return '-';
  
  try {
    const date = new Date(dateString);
    const defaultOptions = {
      timeZone: timezone || 'UTC',
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      ...options
    };
    
    return new Intl.DateTimeFormat('en-GB', defaultOptions).format(date);
  } catch (e) {
    return dateString;
  }
};

// Format time only in exercise timezone
export const formatTimeInTimezone = (dateString, timezone) => {
  if (!dateString) return '-';
  
  try {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-GB', {
      timeZone: timezone || 'UTC',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    }).format(date);
  } catch (e) {
    return dateString;
  }
};

// Format date only in exercise timezone
export const formatDateInTimezone = (dateString, timezone) => {
  if (!dateString) return '-';
  
  try {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-GB', {
      timeZone: timezone || 'UTC',
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    }).format(date);
  } catch (e) {
    return dateString;
  }
};

// Get timezone display label
export const getTimezoneLabel = (timezoneValue) => {
  const tz = TIMEZONES.find(t => t.value === timezoneValue);
  if (tz) return tz.label;
  return timezoneValue;
};

// Get short timezone label
export const getTimezoneShortLabel = (timezoneValue) => {
  if (timezoneValue === 'UTC') return 'UTC';
  if (timezoneValue === 'Europe/London') return 'UK';
  
  const offset = getTimezoneOffset(timezoneValue);
  return `UTC${formatOffset(offset)}`;
};

export default {
  TIMEZONES,
  getTimezoneOffset,
  getUserTimezone,
  getUserOffset,
  formatOffset,
  getRelativeOffset,
  formatInTimezone,
  formatTimeInTimezone,
  formatDateInTimezone,
  getTimezoneLabel,
  getTimezoneShortLabel
};
